import { defineMessages } from 'react-intl';

export default defineMessages({
  text: 'This action will {increase} your health factor! Always try to maintain a positive health factor to avoid liquidation.',
  increase: 'increase',
});
